<template>
    <div>
        <v-navigation-drawer v-model="drawer" app> 
            <v-list dense>
                <v-list-item
                v-for="item in items"
                :key="item.title"
                :href="item.link"
                >
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar app>

            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
            
            <v-toolbar-title>Angela Sette</v-toolbar-title>

            <div class="flex-grow-1"></div>

            <v-btn icon target="_blank" href="https://instagram.com/angelasette">
                <v-icon>mdi-instagram</v-icon>
            </v-btn>

            <v-btn icon target="_blank" href="https://www.facebook.com/angelamsette/">
                <v-icon>mdi-facebook</v-icon>
            </v-btn>

            <v-btn icon target="_blank" href="https://twitter.com/AngelaSette1">
                <v-icon>mdi-twitter</v-icon>
            </v-btn>

        </v-app-bar>
    </div>
</template>

<script>
    export default { 
        data () {
            return {
                drawer: false,
                items: [
                    { title: 'Home', icon: 'mdi-home', link: '/' },
                    { title: 'Book', icon: 'mdi-book-open', link: "/book" },
                    // { title: 'Events', icon: 'mdi-calendar', link: "/events/" },
                    // { title: 'Blog', icon: 'mdi-post', link: "/blog/" },
                    { title: 'About', icon: 'mdi-account', link: "/about" },
                    { title: 'Contact', icon: 'mdi-email', link: "/contact" },
                ],
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>